import { ITypeOption } from "@/components/excel/schema/definiens/bizType";

import {
  DaySelector,
  MonthSelector,
  YearSelector,
} from "@/components/excel/schema/selector/date-time";
import {
  DayMode,
  MonthDayMode,
  MonthMode,
  YearMode,
  YearMonthDayMode,
  YearMonthMode,
} from "@/components/excel/schema/value/mode/date";
const base = 300;
export const YearOption: ITypeOption = {
  value: base + 1,
  text: "年",
  mode: YearMode,
  selector: YearSelector,
};
export const MonthOption: ITypeOption = {
  value: base + 2,
  text: "月",
  mode: MonthMode,
  selector: MonthSelector,
  parent: YearOption,
};
YearOption.child = MonthOption;
export const DayOption: ITypeOption = {
  value: base + 3,
  text: "日",
  mode: DayMode,
  selector: DaySelector,
  parent: MonthOption,
};
MonthOption.child = DayOption;
export const YearMonthOption: ITypeOption = {
  value: base + 4,
  text: "年-月",
  mode: YearMonthMode,
  child: DayOption,
};
export const MonthDayOption: ITypeOption = {
  value: base + 5,
  text: "月-日",
  mode: MonthDayMode,
  parent: YearOption,
};
export const YearMonthDayOption: ITypeOption = {
  value: base + 6,
  text: "年-月-日",
  mode: YearMonthDayMode,
};
